import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllMerchants, deleteMerchant } from "./MerchantService";

export default function MerchantList(){
  const [merchants,setMerchants] = useState([]);
  const nav = useNavigate();

  useEffect(()=>{ load(); },[]);

  const load = async ()=>{
    const data = await getAllMerchants();
    setMerchants(data);
  };

  const handleDelete = async (id)=>{
    if(!window.confirm("Delete merchant?")) return;
    await deleteMerchant(id);
    load();
  };

  return (
    <div className="card">
      <button className="btn btn-primary" onClick={()=>nav("new")}>➕ Add Merchant</button>

      <div className="data-table-wrap">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Active</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {merchants.map(m=>(
              <tr key={m.id}>
                <td>{m.merchantName}</td>
                <td>{m.merchantType}</td>
                <td>{m.active ? "Yes":"No"}</td>
                <td>
                  <button className="btn" onClick={()=>nav(`edit/${m.id}`)}>✏️</button>
                  <button className="btn btn-danger" onClick={()=>handleDelete(m.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
